var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      {
        ref: "button",
        class: {
          "ap-button": true,
          premium: _vm.premium,
          primary: _vm.primary,
          accent: _vm.accent,
          green: _vm.green,
          red: _vm.red,
          large: _vm.large,
          small: _vm.small,
          loading: _vm.loading
        },
        on: { click: _vm.handleClick }
      },
      _vm.$listeners
    ),
    [
      _c("transition", { attrs: { name: "fade-fast", mode: "out-in" } }, [
        _vm.loading
          ? _c(
              "span",
              { staticClass: "loading-wrapper" },
              [
                _c("LoadingAnimation", {
                  attrs: {
                    color: _vm.loadingAnimColor,
                    size: "small",
                    type: "dots"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "button-text" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }